import { Anchor } from "@newsela/angelou";

import { withTrackEvent, actionNames, objectTypes } from "@newsela/snitch";
import { sectionHeadingTextCss } from "../CreateNewClassroomModal.style";
import CanvasSVG from "../ProviderIcons/Canvas/CanvasSVG.svg.jsx";
import ClasslinkSVG from "../ProviderIcons/Classlink/ClasslinkSVG.svg.jsx";
import CleverSVG from "../ProviderIcons/Clever/CleverSVG.svg.jsx";
import GoogleClassroomSVG from "../ProviderIcons/GoogleClassroom/GoogleClassroomSVG.svg.jsx";
import {
  anchorWrapperCss,
  canvasAnchorCss,
  classlinkAnchorCss,
  cleverAnchorCss,
  googleAnchorCss,
  googleIconCss,
  providerIconCss,
  providerTextCss,
  sectionDividerCss,
  sharedAnchorAsButtonCss,
} from "./ImportSection.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const sharedAnchorProps = {
  icon: {
    isIconBeforeText: "true",
  },
  objectType: objectTypes.classroom,
  actionName: actionNames.navigate,
};

const ImportSection = () => {
  return (
    <>
      <div css={sectionDividerCss}>
        <hr />
        <strong>OR</strong>
        <hr />
      </div>
      <h3 css={sectionHeadingTextCss}>Import from an existing account</h3>
      <div css={anchorWrapperCss}>
        <AnchorWithTrackEvent
          streamProperties={{
            description: "Google Classroom",
          }}
          {...sharedAnchorProps}
          __cssFor={{
            root: [sharedAnchorAsButtonCss, googleAnchorCss],
            Icon: {
              root: [providerIconCss, googleIconCss],
            },
          }}
          href="https://support.newsela.com/article/ways-to-create-classes/#google"
          icon={{
            SvgComponent: GoogleClassroomSVG,
          }}
        >
          <span css={providerTextCss}>Google Classroom</span>
        </AnchorWithTrackEvent>
        <AnchorWithTrackEvent
          streamProperties={{
            description: "Clever",
          }}
          {...sharedAnchorProps}
          __cssFor={{
            root: [cleverAnchorCss, sharedAnchorAsButtonCss],
            Icon: {
              root: providerIconCss,
            },
          }}
          href="https://support.newsela.com/article/ways-to-create-classes/#clever"
          icon={{
            SvgComponent: CleverSVG,
          }}
        >
          <span css={providerTextCss}>Clever</span>
        </AnchorWithTrackEvent>
        <AnchorWithTrackEvent
          streamProperties={{
            description: "Canvas",
          }}
          {...sharedAnchorProps}
          __cssFor={{
            root: [canvasAnchorCss, sharedAnchorAsButtonCss],
            Icon: {
              root: providerIconCss,
            },
          }}
          href="https://support.newsela.com/article/ways-to-create-classes/#canvas"
          icon={{
            SvgComponent: CanvasSVG,
          }}
        >
          <span css={providerTextCss}>Canvas</span>
        </AnchorWithTrackEvent>
        <AnchorWithTrackEvent
          streamProperties={{
            description: "Classlink",
          }}
          {...sharedAnchorProps}
          __cssFor={{
            root: [classlinkAnchorCss, sharedAnchorAsButtonCss],
            Icon: {
              root: providerIconCss,
            },
          }}
          href="https://support.newsela.com/"
          icon={{
            SvgComponent: ClasslinkSVG,
          }}
        >
          <span css={providerTextCss}>Classlink</span>
        </AnchorWithTrackEvent>
      </div>
    </>
  );
};

export default ImportSection;
